/** Gedeelde positie/stijl voor rechtsonder onboarding-kaartjes (plan-tour + hints). */
export const onboardingHintCardPositionSx = {
  position: 'absolute',
  right: 16,
  bottom: 16,
  zIndex: 10,
  maxWidth: 360,
  p: 2,
};

/** Fixed variant voor hints buiten een relatieve Today-container (quick-add). */
export const onboardingHintCardFixedPositionSx = {
  position: 'fixed',
  right: 16,
  bottom: 16,
  zIndex: 1300,
  maxWidth: 360,
  p: 2,
};
